import jQuery from "jquery";

// @ts-ignore
import datepicker from "js-datepicker";
import {format} from "date-fns";

jQuery.fn.extend({
    datefield: function(opts?: any) {

        opts = jQuery.extend(opts || {}, {
            formatter: (input: any, date: any, instance: any) => {
                const value = format(date,  "dd/MM/yyyy");
                input.value = value // => '31/1/2099'
                jQuery(input).trigger("change");
            },
            format: "dd/mm/yyyy",
        });

        jQuery(this).each((index, element) => {

            // Don't double-init
            if (jQuery(element).data("datepicker")) {
                return;
            }

            const picker = datepicker(element, opts);

            jQuery(element).data("datepicker", picker);
            jQuery(element).addClass("datefield");
        });
        return this;
    }
});
